import {Spinner} from "react-bootstrap";

const Loading = (props)=>{
  const {visible} = props;
  return (
    <>
      {visible && (<>
        <Spinner animation="border" variant="primary"/>
        </>
      )}
    </>
  );
};
export default Loading;